"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadLocalCredentials = exports.addRawCredentials = exports.removeCredentials = exports.addCredentials = void 0;

var authentication_1 = require("../types/authentication");

var corona_1 = require("corona");

function addCredentials(cred) {
  return {
    type: authentication_1.ADD_CREDENTIALS,
    cred: cred
  };
}

exports.addCredentials = addCredentials;

function removeCredentials() {
  return {
    type: authentication_1.REMOVE_CREDENTIALS
  };
}

exports.removeCredentials = removeCredentials;

exports.addRawCredentials = function (hash) {
  return function (dispatch) {
    try {
      var cred = corona_1.decodeCredentials(hash);

      if (cred.valid()) {
        return cred.store().then(function (cred) {
          var action = addCredentials(cred);
          dispatch(action);
          return action;
        });
      } else {
        var action = addCredentials(cred);
        dispatch(action); // this is kinda a noop as we will just be rejected

        return Promise.resolve(action);
      }
    } catch (Error) {
      var action = addCredentials(new corona_1.Credentials());
      dispatch(action); // this is kinda a no-op as we will just be rejected

      return Promise.resolve(action);
    }
  };
};

exports.loadLocalCredentials = function () {
  return function (dispatch) {
    return new corona_1.Credentials().load().then(function (cred) {
      var action = addCredentials(cred);
      dispatch(action);
      return action;
    });
  };
};